<template>
  <div>
    <div class="input-with-button">
      <composition-input
        class="composition-input"
        :title="variable.title"
        :text="variable.name"
        :info="variable.info"
        :type="variable.variableType"
        :options="options"
        :default-value="variable.defaultValue"
        :is-nested="variable.isNested"
        :is-smart-field="variable.isSmartField"
        @input="$emit('input', $event)"
        @focus="$emit('focus')"
      />
      <div class="button" :class="{ 'button--nested': variable.isNested }" v-if="variable.isRemovable" @click="remove">
        <icon name="trash" :width="24" :height="24" />
        <v-tooltip>Odstrani polje</v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Input from './Input'
import Icon from 'design-system/icons/Icon.vue'
import VTooltip from 'design-system/VTooltip.vue'

export default {
  components: {
    CompositionInput: Input,
    Icon,
    VTooltip,
  },
  props: {
    variable: { type: Object, required: true },
  },
  computed: {
    options () {
      if (!this.variable.variableOptions) {
        return []
      }

      return this.variable.variableOptions.map(option => {
        return {
          label: option.value,
          ...option,
        }
      })
    },
  },
  methods: {
    remove () {
      this.$emit('remove', this.variable.textSegmentId)
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/variables';

.composition-input {
  flex-grow: 1;
}

.input-with-button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  .button {
    margin-top: 36px;
  }
}

.button {
  cursor: pointer;
}
</style>
